// 组队邀请配置 - teamInviteConfig.ts
// 存储组队邀请的静态配置数据

export interface TeamMember {
  name?: string;
  leader?: boolean;
}

export interface TeamAward {
  num: number; // 需要多少人
  pic: string[]; // 奖励图片
  awardDetail: string; // 奖励详情文本
  state: number; // 0:未完成 1:可领取 2:已领取
  key?: string;
}

export interface TeamInviteConfig {
  // 队伍配置
  teamSize: number; // 队伍最大人数

  // 奖励配置
  awardInfo: TeamAward[]; // 队伍奖励列表
  leaderAwardList: TeamAward[]; // 队长专属奖励
  showLeaderAward: boolean; // 是否显示队长奖励

  // 初始队伍成员（用于预览）
  memberInfo: TeamMember[];
}

/**
 * 默认组队邀请配置
 */
export const defaultTeamInviteConfig: TeamInviteConfig = {
  teamSize: 5,

  awardInfo: [
    {
      num: 3,
      pic: ['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png'],
      awardDetail: '奖励1 X 2; 奖励2 X 2',
      state: 0,
    },
    {
      num: 4,
      pic: ['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png'],
      awardDetail: '奖励3 X 3; 奖励4 X 3',
      state: 0,
    },
    {
      num: 5,
      pic: ['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png'],
      awardDetail: '奖励5 X 5; 奖励6 X 5',
      state: 0,
    },
  ],

  leaderAwardList: [
    {
      num: 5,
      pic: ['https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1715240279211-93.png'],
      awardDetail: '队长专属奖励',
      state: 0,
    },
  ],

  showLeaderAward: true,

  memberInfo: [
    { name: '', leader: true }, // 队长
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
  ],
};

/**
 * 图片资源配置
 */
export const teamInviteImages = {
  // 队员头像
  leaderAvatar: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697674-95.png',
  memberAvatar: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713171812387-30.png',
  emptySlot: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/10/1761103574477-14.png',

  // 队长标记
  leaderBadge: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713172450005-62.png',

  // 背景
  teamInfoBg: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/10/1761103955762-33.png',

  // 说明图标
  infoIcon: 'https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/10/1761106673875-43.png',
};
